/**
 * Types de structure juridique du freelance (colonne `freelancer_profiles.legal_entity_type`).
 *
 * Source de vérité : enum Postgres `legal_entity_type`
 * (packages/nextjs/supabase/migrations/001_create_enums.sql + 181_add_portage_to_legal_entity_type.sql).
 *
 * Historiquement, ces valeurs étaient des littéraux dispersés dans ~20 fichiers. Ce module les
 * centralise pour le code neuf (portage salarial). Les i18n keys pointent vers
 * `freelancerOnboarding.typeSelection.*`.
 */
export const LEGAL_ENTITY_TYPE = {
  AUTO_ENTREPRENEUR: 'auto-entrepreneur',
  COMPANY: 'company',
  PORTAGE: 'portage-salarial',
} as const

export type LegalEntityType = (typeof LEGAL_ENTITY_TYPE)[keyof typeof LEGAL_ENTITY_TYPE]

/** i18n key (sous `freelancerOnboarding.typeSelection`) du label de chaque type. */
export const LEGAL_ENTITY_TYPE_LABEL_KEY: Record<LegalEntityType, string> = {
  [LEGAL_ENTITY_TYPE.AUTO_ENTREPRENEUR]: 'freelancerOnboarding.typeSelection.autoEntrepreneur',
  [LEGAL_ENTITY_TYPE.COMPANY]: 'freelancerOnboarding.typeSelection.company',
  [LEGAL_ENTITY_TYPE.PORTAGE]: 'freelancerOnboarding.typeSelection.portage',
}

export const isPortage = (type: string | null | undefined): boolean =>
  type === LEGAL_ENTITY_TYPE.PORTAGE
